import groupPanel from "../../Assets/Images/group-panel.png";
import groupPanelMobile from "../../Assets/Images/group-panel-mobile.png";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import individualPanel from "../../Assets/Images/individual-panel.png";
import individualPanelMobile from "../../Assets/Images/individual-panel-mobile.png";

export default function Announcement(props) {
  const location = useLocation();

  // variations -- group / individual // mobile / desktop

  return (
    <>
      <div className="hidden sm:block">
        {location.pathname.includes("/skillzone/group") ? (
          <Link
            to={`/skillzone/${props.bookingReference}`}
            state={{ bookingReference: props.bookingReference }}
          >
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f5a041",
                padding: "0.5rem 1rem",
              }}
            >
              <div></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  fontWeight: "bold",
                }}
              >
                <img src={individualPanel} alt="Group Icon" className="h-10 z-20" />
              </div>
            </div>
          </Link>
        ) : (
          props.users > 1 && (
            <Link
              to={`/skillzone/group/${props.bookingReference}`}
              state={{ bookingReference: props.bookingReference }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#98dcb4",
                  padding: "0.5rem 1rem",
                }}
              >
                <div></div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    fontWeight: "bold",
                  }}
                >
                  <img src={groupPanel} alt="Group Icon" className="h-10 z-20" />
                </div>
              </div>
            </Link>
          )
        )}
      </div>

      <div className="block sm:hidden fixed top-0 left-0 w-full z-50">
        {location.pathname.includes("/skillzone/group") ? (
          <Link
            to={`/skillzone/${props.bookingReference}`}
            state={{ bookingReference: props.bookingReference }}
          >
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f5a041",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                <img
                  src={individualPanelMobile}
                  alt="Group Icon"
                  className="h-10 z-100"
                />
              </div>
            </div>
          </Link>
        ) : (
          props.users > 1 && (
            <Link
              to={`/skillzone/group/${props.bookingReference}`}
              state={{ bookingReference: props.bookingReference }}
            >
              <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#98dcb4",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "bold",
                  }}
                >
                  <img
                    src={groupPanelMobile}
                    alt="Group Icon"
                    className="h-10 z-100"
                  />
                </div>
              </div>
            </Link>
          )
        )}
      </div>
    </>
  );
}
